import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-become-partner',
  templateUrl: './become-partner.component.html',
  styleUrls: ['./become-partner.component.css']
})
export class BecomePartnerComponent {
  formData = {
    name: '',
    email: '',
    phone: '',
    location: '',
    background: '',
    whyInterested: '',
    submittedAt: null as any,
  };

  submitted = false;

  constructor(
    private firestore: AngularFirestore,
    private meta: Meta,
  ) {}

  ngOnInit() {
    this.meta.updateTag({ name: 'description', content: 'Become a Chareety Sales Partner. Earn lifetime commissions helping nonprofits modernize their donations. No quotas, no territories, no upfront investment.' });
  }

  submitForm() {
    if (this.formData.name && this.formData.email && this.formData.phone && this.formData.whyInterested) {
      this.formData.submittedAt = new Date();
      this.firestore.collection('/partnerInterest').add(this.formData)
        .then(() => {
          this.submitted = true;
        })
        .catch(err => {
          console.error('Error submitting interest:', err);
          alert('Something went wrong. Please try again or email us at admin@chareety.com');
        });
    }
  }
}
